import React from "react";
import "../../styles/footer.css";

const Footer = () => {
  return (
    <footer className="footer">
      <p className="footer-text">
        Copyright &copy; 2025{" "}
        <a href="https://www.big.go.id/" className="footer-link">
          Badan Informasi Geospasial
        </a>{" "}
        - All Rights Reserved.
      </p>
    </footer>
  );
};

export default Footer;